define('views/header/Podio.Views.HeaderDropdown',['require','underscore','jquery','lib/backbone/Backbone.PodioView'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');

  return ViewPodioBase.extend({
    initialize : function(options) {
      _.bindAll(this, 'render', 'onOutsideClick');

      this.elm = $(this.el);

      this.elmAriaButton = this.elm.find('[aria-role="button"]');
      this.elmDropdown = this.elm.find('.podio-global-help-dropdown');
    },

    render : function() {
      return this;
    },

    dispose: function() {
      this.remove();
    },

    isOpen: function() {
      return this.elm.hasClass('expanded');
    },

    expand: function() {

      var expandedWidth = 300;

      if (this.isOpen()) {
        this.collapse();
        return;
      }

      this.elm.addClass('expanded');
      this.elm.removeClass('collapsed');
      this.elm.bind('outsideclick', this.onOutsideClick);
      this.elm.find('.icon').removeClass('tooltip');

      this.elmDropdown.css({
        'width' : expandedWidth + 1,
        'left' : (expandedWidth + 1 - this.elm.outerWidth()) * -1
      });
      this.elmAriaButton.attr('aria-expanded', true);
      this.elmDropdown.attr('aria-hidden', false);
    },

    collapse: function() {
      if (!this.isOpen()) {
        return;
      }

      this.elm.removeClass('expanded');
      this.elm.addClass('collapsed');

      this.elmDropdown.attr('aria-hidden', true);
      this.elmAriaButton.attr('aria-expanded', false).trigger('blur');

      this.elm.unbind('outsideclick');
      this.elm.find('.icon').addClass('tooltip');
    },

    onOutsideClick : function() {
      this.collapse();
    }

  });


});

